// src/components/admin/template/SelectionModeToggle.tsx

import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import SelectAllIcon from '@mui/icons-material/SelectAll';

export type SelectionType =
  | 'none'
  | 'fields'
  | 'sections'
  | 'groups'
  | 'groupings';

interface SelectionModeToggleProps {
  isSelectionMode: boolean;
  onToggle: (isSelectionMode: boolean) => void;
  selectionType: SelectionType;
  selectionCount: number;
}

const SelectionModeToggle: React.FC<SelectionModeToggleProps> = ({
  isSelectionMode,
  onToggle,
  selectionType,
  selectionCount,
}) => {
  return (
    <Tooltip
      title={isSelectionMode ? 'Exit Selection Mode' : 'Enter Selection Mode'}
    >
      <Badge
        badgeContent={selectionCount}
        color="primary"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        invisible={!isSelectionMode || selectionCount === 0}
      >
        <IconButton
          onClick={() => onToggle(!isSelectionMode)}
          color={isSelectionMode ? 'primary' : 'default'}
        >
          <SelectAllIcon />
        </IconButton>
      </Badge>
    </Tooltip>
  );
};

export default SelectionModeToggle;
